// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"VL-z","inlineTitle":"WL-z","sponsoredAdsWrapper":"XL-z","marketplaceRecosWrapper":"YL-z"};